import React, { useEffect, useState } from "react";
import { gam } from "../lib/gamificationApi";
import { TopBar } from "../components/Navigation";
import WeeklyChallenges from "../components/WeeklyChallenges";
import LevelBadge from "../components/LevelBadge";
import { useAuth } from "../lib/AuthContext";
import { useGamification } from "../lib/GamificationContext";
import { Trophy } from "lucide-react";

export default function Challenges() {
    const { user } = useAuth();
    const { level } = useGamification();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!user) return;
        let cancel = false;
        (async () => {
            try {
                const { items } = await gam.challenges();
                if (!cancel) setItems(items || []);
            } finally {
                if (!cancel) setLoading(false);
            }
        })();
        return () => { cancel = true; };
    }, [user]);

    return (
        <div data-testid="challenges-page">
            <TopBar title="Challenges" />
            <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-10 space-y-6">
                <header>
                    <div className="text-[10px] font-bold uppercase tracking-[0.3em] text-slate-gray">Make every week count</div>
                    <h1 className="font-display font-black text-3xl sm:text-4xl text-midnight-pine tracking-tight">Weekly + Monthly Challenges</h1>
                    <p className="text-sm text-slate-gray mt-1 max-w-xl">
                        Quick prompts to nudge you outside. Complete them, earn XP, and level up your adventure identity.
                    </p>
                </header>

                {level && (
                    <LevelBadge levelData={level} variant="hero" linkable={false} testIdPrefix="challenges-level" />
                )}

                {loading ? (
                    <div data-testid="challenges-loading" className="bg-snowcap border border-ridge-line rounded-xl p-6 text-center">
                        <Trophy className="w-10 h-10 text-slate-gray mx-auto mb-2 animate-pulse" />
                        <p className="text-sm text-slate-gray">Loading challenges…</p>
                    </div>
                ) : (
                    <WeeklyChallenges items={items} />
                )}
            </div>
        </div>
    );
}
